import { Component } from "react";
import { caseTransformingAxios as axios } from "@shared/v2/caseTransformingAxios";
import BulkReportsOptionsModal from "./BulkReportsOptionsModal";
import BulkReportsNoPlatformModal from "./BulkReportsNoPlatformModal";
import HubspotRequestDemoModal from "../../shared/HubspotRequestDemoModal";

class BulkApplyMarketReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsModalOpen: false,
      noPlatformModalOpen: false,
      selectedLeads: [],
      marketReportCount: 0,
      homeValueReportCount: 0,
      validReportCount: 0,
      validIdsWithAddressMarketReport: [],
      validIdsWithReports: [],
      mode: "create",
      showGetDemo: false,
    };
  }

  closeOptionsModal = () => {
    this.setState({ optionsModalOpen: false });
  };

  changeReports = (data) => {
    const path = `/bulk_market_reports/bulk_change_reports`;

    axios
      .post(path, { authenticity_token: ReactOnRails.authenticityToken(), data: data })
      .then((res) => console.log("Bulk Change Reports Done", res))
      .catch((err) => console.log("ERROR", err));
  };

  createReports = (data) => {
    const path = `/bulk_market_reports/bulk_create_reports`;

    axios
      .post(path, { authenticity_token: ReactOnRails.authenticityToken(), data: data })
      .then((res) => console.log("Bulk Create Reports Done", res))
      .catch((err) => console.log("ERROR", err));
  };

  showStatusModal = (data, mode) => {
    if (mode === "create") {
      data.contacts = this.state.validIdsWithAddressMarketReport;
      this.createReports(data);
    } else if (mode === "change") {
      data.contacts = this.state.validIdsWithReports;
      this.changeReports(data);
    }
    this.setState({ optionsModalOpen: false, mode: mode });
  };

  getValidLeads = () => {
    const path = `/bulk_market_reports/valid_leads`;
    let ids = Brivity.PeoplePage.grid().multiSelect().getSelectedObjectIds();

    axios.get(path, { params: { people_ids: ids } }).then((res) => {
      this.setState({
        optionsModalOpen: true,
        marketReportCount: res.data.marketReportCount,
        homeValueReportCount: res.data.homeValueReportCount,
        validIdsWithAddressMarketReport: res.data.peopleWithAddresses,
        validReportCount: res.data.withReport.length,
        validIdsWithReports: res.data.withReport,
        selectedLeads: ids,
      });
    });
  };

  closeNoPlatformModal = (cancel) => {
    if (!cancel) {
      this.setState({ noPlatformModalOpen: false, showGetDemo: true });
    } else {
      this.setState({ noPlatformModalOpen: false });
    }
  };

  onClick = (e) => {
    if (e.currentTarget.closest("#mass-update-market-reports.disabled")){
      e.stopPropagation();
      return;
    }
    if (this.props.platform) {
      this.getValidLeads();
    } else {
      this.setState({ noPlatformModalOpen: true });
    }
  };

  renderOptionsModal = () => {
    return (
      this.state.optionsModalOpen && (
        <BulkReportsOptionsModal
          country={this.props.country}
          selectedLeads={this.state.selectedLeads}
          marketReportCount={this.state.marketReportCount}
          homeValueReportCount={this.state.homeValueReportCount}
          validReportCount={this.state.validReportCount}
          showStatusModal={this.showStatusModal}
          closeOptionsModal={this.closeOptionsModal}
        />
      )
    );
  };

  renderNoPlatformModal = () => {
    return (
      this.state.noPlatformModalOpen && (
        <BulkReportsNoPlatformModal closeNoPlatformModal={this.closeNoPlatformModal} />
      )
    );
  };

  closeRequestDemo = () => {
    this.setState({ showGetDemo: false });
  };

  render() {
    return (
      <div>
        <div onClick={this.onClick}>Market Report</div>
        {this.renderNoPlatformModal()}
        {this.renderOptionsModal()}
        <HubspotRequestDemoModal show={this.state.showGetDemo} onClose={this.closeRequestDemo} />
      </div>
    );
  }
}

export default BulkApplyMarketReports;
